export default __webpack_public_path__ + "static/media/youtube.1cb296b2.svg";